<script>
import Layout from "../../../../layouts/main";
import PageHeader from "../../../../components/page-header";
import FolderFileSection from "../FolderFileSection/FolderFileSection.vue";
import axios from "axios";
import { eventBus } from "../../../../assets/eventBus";
import { piniaPlugin } from "../../../../stores";
import FloatingButton from "../../../../components/buttons/FloatingButton.vue";

export default {
    components: { Layout, PageHeader, FolderFileSection, FloatingButton },
    props: {
        allTrashFoldersFiles: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            title: "Trash",
            items: [
                {
                    text: "Apps",
                    href: "/",
                },
                {
                    text: "Trash",
                    active: true,
                },
            ],
            allFoldersFiles: [],
            recentFiles: [],
            searchValue: null,
        };
    },
    setup() {
        const store = piniaPlugin();
        return { store };
    },
    computed: {
        // Example Admin, Enterprise Partner, Tax Company, Tax Payer
        browserTitle() {
            return this.$page.props.auth.user.user_type_text + " - Trash";
        },
        // Example admin, sb, tc, tp
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        },
        isShowActionButton() {
            return this.store.useMultiSelect.isShowActionButton;
        },
        allMoreOptions() {
            return [
                {
                    title: "Restore",
                    onClickMethod: (userTypeAbbr) =>
                        this.store.useTrashStore.restoreFolderFile(
                            userTypeAbbr
                        ),
                    iconClass: "bx bx-rotate-left",
                    bgcolor: "btn-success",
                },
                {
                    title: "Delete forever",
                    onClickMethod: (userTypeAbbr) =>
                        this.store.useTrashStore.deleteFolderFile(userTypeAbbr),
                    iconClass: "bx bxs-trash-alt",
                    bgcolor: "btn-danger",
                },
            ];
        },
    },
    watch: {
        isShowActionButton(value) {
            this.store.useTrashStore.isShowMoreOption = false;
        },
    },
    methods: {
        manageFetchingDataRoute(fetchingDataRoute, param, paramValue) {
            let baseURL = fetchingDataRoute.split("?");
            let routeStringParam = {};
            if (baseURL.length > 1) {
                let allParam = baseURL[1].split("&");
                let strings = null;
                for (let i = 0; i < allParam.length; i++) {
                    strings = allParam[i].split("=");
                    routeStringParam[strings[0]] = strings[1];
                }
            }
            routeStringParam[param] = paramValue;
            return route(this.userTypeAbbr + "-trash-folders-files", [
                routeStringParam,
            ]);
        },

        fetchingData(url, fetchingType, dataType = "default") {
            axios
                .get(url, {})
                .then((response) => {
                    this.allFoldersFiles = response.data;
                    this.triggerOnMounted(fetchingType, dataType);
                    setTimeout(() => {
                        eventBus.documentManagerLoading("Folder", false);
                    }, 300);
                })
                .catch((errors) => {
                    this.$toastr.e(errors.message);
                    setTimeout(() => {
                        eventBus.documentManagerLoading("Folder", false);
                    }, 300);
                });
        },
        triggerOnMounted(type, dataType) {
            if (type === "Search") {
                this.$refs.FolderFileSection.onMounted("search", "default");
            } else if (type === "Delete") {
                setTimeout(() => {
                    this.$refs.FolderFileSection.onMounted("delete", dataType);
                }, 200);
            } else if (type === "Add") {
                setTimeout(() => {
                    this.$refs.FolderFileSection.onMounted("add", dataType);
                }, 200);
            }
        },
    },
    created() {
        this.searchValue = null;
        eventBus.documentManagerLoading("Folder", true);
        let fetchingDataRoute = route(
            this.userTypeAbbr + "-trash-folders-files"
        );
        this.allFoldersFiles = this.allTrashFoldersFiles;
        this.fetchingData(fetchingDataRoute, "Normal");

        eventBus.$off("searchFoldersFiles");
        eventBus.$on("searchFoldersFiles", (value) => {
            eventBus.documentManagerLoading("Folder", true);
            fetchingDataRoute = this.manageFetchingDataRoute(
                fetchingDataRoute,
                "search",
                value
            );
            this.fetchingData(fetchingDataRoute, "Search");
            this.searchValue = value;
        });
        eventBus.$off("sortingColumn");
        eventBus.$on("sortingColumn", (datas) => {
            eventBus.documentManagerLoading("Folder", true);
            fetchingDataRoute = this.manageFetchingDataRoute(
                fetchingDataRoute,
                datas.item,
                datas.value
            );
            this.fetchingData(fetchingDataRoute, "Sort");
        });

        eventBus.$off("reloadFolderFile");
        eventBus.$on("reloadFolderFile", (value) => {
            this.fetchingData(
                fetchingDataRoute,
                value.valuecheck,
                value.typecheck
            );
        });
    },
};
</script>

<template>
    <Layout>
        <Head :title="browserTitle" />
        <PageHeader :title="title" :items="items" />
        <div class="d-xl-flex minVh">
            <div class="w-100">
                <div class="d-flex flex-column gap-4">
                    <div
                        class="d-flex align-items-center gap-2 text-info text-gradient fs-5"
                    >
                        <i class="bx bx-time"></i>
                        <span>Items are deleted forever after 30 days.</span>
                    </div>
                    <FolderFileSection
                        ref="FolderFileSection"
                        :myFolders="allFoldersFiles"
                        :recentFiles="recentFiles"
                        folderTitle="Trash Management"
                        fileTitle="Recent Files"
                        folderType="OwnContent"
                        fileType="OwnContent"
                        noDataFolderTitle="<i class='bx bxs-trash'></i> Nothing in Trash."
                        noDataFileTitle="No Files Available."
                        routeType="Trash"
                    />
                </div>
            </div>
        </div>
        <div v-if="store.useMultiSelect.isShowActionButton">
            <FloatingButton
                customFloatClasses="float my-2"
                :isShowMoreOption="store.useTrashStore.isShowMoreOption"
                :userTypeAbbr="userTypeAbbr"
                :isShowActionButton="store.useMultiSelect.isShowActionButton"
                :showOptionsButton="store.useTrashStore.showOptionsButton"
                :allMoreOptions="allMoreOptions"
            />
        </div>
    </Layout>
</template>

<style scoped>
.minVh {
    min-height: calc(100vh - 40vh);
}

.float {
    position: fixed;
    width: fit-content;
    height: fit-content;
    bottom: 30px;
    right: 70px;
}
</style>
